import NumberFlow, { continuous } from '@number-flow/react';

import { cn } from '@/utils/twx';

type SummaryChipColor = 'gray' | 'blue' | 'green' | 'red';

const BG: Record<SummaryChipColor, string> = {
  gray: 'bg-cds-coolgray-10',
  blue: 'bg-cds-blue-20',
  green: 'bg-cds-green-20',
  red: 'bg-cds-red-20',
};

const COUNT_COLOR: Record<SummaryChipColor, string> = {
  gray: 'text-cds-coolgray-75',
  blue: 'text-cds-blue-60',
  green: 'text-cds-green-60',
  red: 'text-cds-red-60',
};

type SummaryChipProps = {
  label: string;
  count: number;
  color: SummaryChipColor;
  unit?: string;
  className?: string;
};

const SummaryChip = ({ label, count, color, unit = '개', className }: SummaryChipProps) => (
  <span
    className={cn(
      'inline-flex h-[34px] items-center gap-[4px] rounded-[10px] px-[12px] text-[14px] leading-none text-cds-coolgray-65',
      BG[color],
      className,
    )}
  >
    {label}
    {/* 숫자와 단위(개)는 한 그룹으로 묶어 붙임 — "100개" (라벨과의 gap만 유지: "총 100개") */}
    <span className="inline-flex items-center">
      <b className={cn('font-semibold tabular-nums', COUNT_COLOR[color])}>
        <NumberFlow willChange plugins={[continuous]} value={count} />
      </b>
      {unit}
    </span>
  </span>
);

export default SummaryChip;
